import { render, staticRenderFns } from "./MomentCreateGoodsRemarkPage.vue?vue&type=template&id=5909fd02&scoped=true&"
import script from "./MomentCreateGoodsRemarkPage.vue?vue&type=script&lang=js&"
export * from "./MomentCreateGoodsRemarkPage.vue?vue&type=script&lang=js&"
import style0 from "./MomentCreateGoodsRemarkPage.vue?vue&type=style&index=0&id=5909fd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909fd02",
  null
  
)

export default component.exports